export type FlightSearchFormLabels = {
  addFlight: string;
  close: string;
  departureDate: string;
  destination: string;
  done: string;
  errors: {
    departureDate: string;
    destination: string;
    laterReturnDate: string;
    matchingOriginAndDestination: string;
    minMultiCityRoutes: string;
    origin: string;
    returnDate: string;
  };
  loyaltyCheckbox: string;
  origin: string;
  passengersDropdown: {
    adult: string;
    adults: string;
    adultsRestrictions: string;
    child: string;
    children: string;
    childrenRestrictions: string;
    decrement: string;
    increment: string;
    infant: string;
    infants: string;
    infantsRestrictions: string;
    maximumChildren: string;
    maximumInfants: string;
    maximumTravelers: string;
    needHelp: TrustedHTML;
    specialAssistance: TrustedHTML;
    travelers: string;
  };
  promoCode: string;
  removeFlight: string;
  reset: string;
  returnDate: string;
  returnDateError: string;
  submit: string;
  swap: string;
  swapAnnouncement: string;
  tripType: {
    multiCity: string;
    oneWay: string;
    roundTrip: string;
  };
};
export const DEFAULT_LABELS = {
  addFlight: "Add Flight",
  close: "Close",
  departureDate: "Depart",
  destination: "To",
  done: "Done",
  errors: {
    departureDate: "Enter a date",
    destination: "Select a city",
    laterReturnDate: "Return date must be on or after departure date",
    matchingOriginAndDestination: "Origin and destination cannot be the same",
    minMultiCityRoutes: "Multi-city trips require at least 2 routes",
    origin: "Select a city",
    returnDate: "Enter a date",
  },
  loyaltyCheckbox: "Use TrueBlue points",
  origin: "From",
  passengersDropdown: {
    adult: "Adult",
    adults: "Adults",
    adultsRestrictions: "Adults",
    child: "Child",
    children: "Children",
    childrenRestrictions: "Children",
    decrement: "Remove one",
    increment: "Add one",
    infant: "Infant",
    infants: "Infants",
    infantsRestrictions: "Infants",
    maximumChildren: "Maximum Children",
    maximumInfants: "Maximum Infants",
    maximumTravelers: "Maximum Travelers",
    needHelp: "Need Help?",
    specialAssistance: "Special Assistance",
    travelers: "Travelers",
  },
  promoCode: "Promo code",
  removeFlight: "Remove Flight",
  reset: "Reset",
  returnDate: "Return",
  returnDateError: "Enter a date",
  submit: "Search Flights",
  swap: "Swap",
  swapAnnouncement: "Origin and destination swapped.",
  tripType: {
    multiCity: "Multi-City",
    oneWay: "One Way",
    roundTrip: "Round Trip",
  },
} satisfies FlightSearchFormLabels;
